export enum FilterTypeEnum {
  CALENDAR = 'Calendar',
  DROPDOWN = 'Dropdown',
  AUTOCOMPLETE = 'Autocomplete',
  NO_FILTER = 'No filter'
}

export interface Filters {
  title: string;
  filterType: FilterTypeEnum;
  tooltip?: string; // Clave de traducción para el tooltip
}

export interface ColumnConfig {
  name: string;
  tooltip?: string; // Clave de traducción para el tooltip
}
